/**
 * 說明 : 角色與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import {createAsyncThunk} from '@reduxjs/toolkit';

// ----- import from Base API -----
import BaseAPI from './BaseAPI';

// 新增角色
export const addRole = createAsyncThunk(
  'role/addRole',
  async (role, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/setting/role', role, token);
      return data;
    } catch (err) {
      console.error('add role error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改角色
export const editRole = createAsyncThunk(
  'role/editRole',
  async (role, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/role', role, token);
      return data;
    } catch (err) {
      console.error('edit role error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改角色狀態
export const editRoleStatus = createAsyncThunk(
  'role/editRoleStatus',
  async ({roleId, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/role/status', {roleId: roleId, flgStatus: status}, token);
      return data;
    } catch (err) {
      console.error('edit role error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得單筆角色資料
export const fetchRole = createAsyncThunk(
  'role/fetchRole',
  async (roleId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(`/setting/role/${roleId}`, null, token);
      return data;
    } catch (err) {
      console.error('fetch role error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得角色維護清單列表
export const fetchRoleList = createAsyncThunk(
  'role/fetchRoleList',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/setting/role', null, token);
      return data;
    } catch (err) {
      console.error('fetch role list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的角色名稱選單
export const fetchRoleSelection = createAsyncThunk(
  'role/fetchRoleSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/selection/role', null, token);
      return data;
    } catch (err) {
      console.error('fetch role selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
